'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkerShapeForModel;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseModel = require('../damo/baseModel');

var _baseModel2 = _interopRequireDefault(_baseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modelShape = {
  displayName: _propTypes2.default.string,
  store: _propTypes2.default.object,
  state: _propTypes2.default.object,
  actions: _propTypes2.default.object.isRequired,
  effects: _propTypes2.default.object,
  subscriptions: _propTypes2.default.object
};

// # Model接口定义，并提供校验是否合法的方法
function checkerShapeForModel(model, location) {
  return model.prototype instanceof _baseModel2.default || _propTypes2.default.checkPropTypes(modelShape, model, location, 'Beatle');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/model.js
// module id = 91
// module chunks = 0